export default "__VITE_ASSET__DkC4tYwV__"